import VerifyOtherCardDetails from './VerifyOtherCardDetails';

export default VerifyOtherCardDetails;
